import React from "react";
import { CajaRow3 } from "../../../../../components/cajaRow3/CajaRow3";

export const LocalCarreteroItem = ({ localCarretero }) => {
  const { localCarretero: nombre, cantidad, monto } = localCarretero;
  return <CajaRow3 nombre={nombre} cantidad={cantidad} monto={monto} />;
};
